module.exports = "/assets/data/ff831b2588f80b40a1eff78ebb6b7c64-SG18.data.json";